



























import { Component, Vue } from 'vue-property-decorator';

import { DateInput, toShortDate } from '@/common/datetime';
import { DailyReportStore } from '@/store/dailyReport';

@Component({
  components: {
    DateInput,
  },
})
export default class IndexPageDateRange extends Vue {

  @DailyReportStore.Bind.State startDate!: DailyReportStore.State<'startDate'>;
  @DailyReportStore.Bind.State endDate!: DailyReportStore.State<'endDate'>;
  @DailyReportStore.Bind.Action fetch!: DailyReportStore.Action<'fetch'>;

  todaysDate = toShortDate(new Date());

  updateReports(startDate: string, endDate: string) {
    this.fetch({ startDate, endDate });
  }

}
